
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/pairs",
      function () {
        return require("private-next-pages/embed/pairs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/pairs"])
      });
    }
  